import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsCopilotAdoptionCommunityAdminFREEnabled = () => boolean;
export const useIsCopilotAdoptionCommunityAdminFREEnabled: UseIsCopilotAdoptionCommunityAdminFREEnabled = () =>
  useExperimentTreatmentWithoutReporting('CopilotAdoptionCommunityAdminFRE') === true;
